import { CommonModule } from '@angular/common';
import { Component, inject, NgZone, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { PageComponent, PageHeaderComponent } from '@softapps/core/pages';
import { Lagerplatz, LagerplatzSucheComponent } from '@softapps/lager/core';
import {
  BackNavigable,
  BackNavigationService,
  BlockingLoadingSpinnerComponent,
  HeaderComponent,
  ScannerModule,
  showRequestErrors,
  SOFTLINE_FEATURE_TITLE,
  TitleStore,
} from '@softline/application';
import { Store } from '@softline/core';
import { BehaviorSubject } from 'rxjs';
import { SOFTLINE_FEATURE_LAGERKORREKTUR } from '../../lagerkorrektur.shared';
import { LagerkorrekturStore } from '../../store';

import { TranslatePipe } from '@softline/ui-core';
import { type ProgressStep, ProgressStepsComponent } from '@softline/ui-core/progress';
@Component({
  selector: 'soft-quelllagerplatz-scannen',
  imports: [
    CommonModule,
    ScannerModule,
    ProgressStepsComponent,
    BlockingLoadingSpinnerComponent,
    LagerplatzSucheComponent,
    HeaderComponent,
    PageHeaderComponent,
    PageComponent,
    TranslatePipe,
  ],
  templateUrl: './lagerplatz-scannen.page.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./lagerplatz-scannen.page.css'],
})
export class LagerplatzScannenPage implements OnInit, OnDestroy, BackNavigable {
  private readonly store = inject(Store);
  private readonly router = inject(Router);
  private readonly backNavigationService = inject(BackNavigationService);

  readonly steps: ProgressStep[] = [
    {
      header: '#LAGERKORREKTUR.PAGES.LAGERPLATZ_SCANNEN.TITLE',
      subHeader: '#LAGERKORREKTUR.PAGES.LAGERPLATZ_SCANNEN.DESCRIPTION',
    },
    {
      header: '#LAGERKORREKTUR.PAGES.ARTIKEL_AUSWAHL.TITLE',
      subHeader: '#LAGERKORREKTUR.PAGES.ARTIKEL_AUSWAHL.DESCRIPTION',
    },
    {
      header: '#LAGERKORREKTUR.PAGES.MENGEN_AUSWAHL.TITLE',
      subHeader: '#LAGERKORREKTUR.PAGES.MENGEN_AUSWAHL.DESCRIPTION',
    },
    {
      header: '#LAGERKORREKTUR.PAGES.LAGERSYMBOL_AUSWAHL.TITLE',
      subHeader: '#LAGERKORREKTUR.PAGES.LAGERSYMBOL_AUSWAHL.DESCRIPTION',
    },
  ];

  loading$ = new BehaviorSubject<boolean>(false);

  constructor() {
    //
  }

  async ngOnInit(): Promise<void> {
    this.backNavigationService.set(this);
    this.store.commit(
      SOFTLINE_FEATURE_TITLE,
      TitleStore.mutations.setTitle,
      '#LAGERKORREKTUR.TITLE'
    );
  }

  ngOnDestroy() {
    this.store.commit(SOFTLINE_FEATURE_TITLE, TitleStore.mutations.setTitle, '');
    this.backNavigationService.set(undefined);
  }

  async navigateBack(): Promise<void> {
    await this.router.navigate(['/']);
  }

  async onLagerplatzSelected(lagerplatz: Lagerplatz): Promise<void> {
    if (!lagerplatz) return;

    this.loading$.next(true);
    try {
      await this.store.dispatch(
        SOFTLINE_FEATURE_LAGERKORREKTUR,
        LagerkorrekturStore.actions.loadLagerplatz,
        lagerplatz.barcode
      );
      this.loading$.next(false);
      await this.router.navigate(['/lagerkorrektur/artikel-auswahl']);
    } catch (e) {
      this.loading$.next(false);
      showRequestErrors(this.store, e);
    }
  }
}
